import useResendCodeTimer from '~/client/components/2faManaging/hooks/useResendCodeTimer';
import OptionsButton from './OptionsButton';
import ArrowsUpdate from '@/external/icons/ArrowsUpdate';

type Props = {
  onResendCodeClick: () => void;
};
const ResendCodeButton: FC<Props> = ({ onResendCodeClick }) => {
  const { handleResendClick, timeLeftFormatted, isTimeOver } =
    useResendCodeTimer(onResendCodeClick);
  const buttonText = isTimeOver
    ? 'profile.send_code_again'
    : 'profile.resend_code_in';

  return (
    <OptionsButton
      data-testid="resend-code-button"
      translateId={buttonText}
      onClick={handleResendClick}
      disabled={!isTimeOver}
      timeLeftFormatted={timeLeftFormatted}
    >
      <ArrowsUpdate />
    </OptionsButton>
  );
};

export default ResendCodeButton;
